import React, { useEffect, useMemo, useState } from 'react';
import '../styles/Description.css';

const Description = () => {
  const aboutUrl = useMemo(() => `${process.env.PUBLIC_URL || ''}/about.txt`, []);
  const [paragraphs, setParagraphs] = useState([]);
  const [status, setStatus] = useState('loading'); // loading | ready | missing

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setStatus('loading');
        const res = await fetch(aboutUrl, { method: 'GET' });
        if (!res.ok) {
          setStatus('missing');
          return;
        }
        const text = await res.text();
        if (cancelled) return;

        const nextParagraphs = String(text || '')
          .split(/\n\s*\n/g)
          .map((p) => p.replace(/\n/g, ' ').trim())
          .filter(Boolean);

        setParagraphs(nextParagraphs);
        setStatus('ready');
      } catch (error) {
        if (cancelled) return;
        setStatus('missing');
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [aboutUrl]);
  return (
    <section id="about" className="section section-card about">
      <div className="section-head">
        <h2 className="section-title">About</h2>
        <p className="section-subtitle">The short version, with just enough detail.</p>
      </div>

      <div className={`description-content ${paragraphs.length <= 1 ? 'is-single' : ''}`}>
        {status === 'loading' ? (
          <p className="section-muted">Loading about…</p>
        ) : status === 'missing' ? (
          <p className="section-muted">Could not load CV summary.</p>
        ) : paragraphs.length > 0 ? (
          paragraphs.map((paragraph, i) => <p key={`p-${i}`}>{paragraph}</p>)
        ) : (
          <p className="section-muted">No summary yet.</p>
        )}
      </div>
    </section>
  );
};

export default Description;
